import { createAction } from '@ngrx/store';

export const initializeServiceWorker = createAction('[ServiceWorker] Initialize ServiceWorker');

export const registerUpdateAvailable = createAction('[ServiceWorker] Register Update Available');

export const checkForUpdates = createAction('[ServiceWorker] Check For Updates');
